/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_DndInputs */

const en_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag-and-drop with keyboard alternative (@dnd-kit)`)
};

const de_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag-and-Drop mit Tastatur-Alternative (@dnd-kit)`)
};

const fr_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glisser-deposer avec alternative clavier (@dnd-kit)`)
};

const es_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastrar y soltar con alternativa de teclado (@dnd-kit)`)
};

const it_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag-and-drop con alternativa tastiera (@dnd-kit)`)
};

const nl_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag-and-drop met toetsenbordaalternatief (@dnd-kit)`)
};

const pl_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeciagnij i upusc z alternatywa klawiaturowa (@dnd-kit)`)
};

const fi_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedä ja pudota -toiminto näppäimistövaihtoehdolla (@dnd-kit)`)
};

const da_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag-and-drop med tastaturalternativ (@dnd-kit)`)
};

const sv_a11y_statement_accessible_dnd = /** @type {(inputs: A11y_Statement_Accessible_DndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dra-och-slapp med tangentbordsalternativ (@dnd-kit)`)
};

/**
* | output |
* | --- |
* | "Drag-and-drop with keyboard alternative (@dnd-kit)" |
*
* @param {A11y_Statement_Accessible_DndInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_dnd = /** @type {((inputs?: A11y_Statement_Accessible_DndInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_DndInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_dnd(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_dnd(inputs)
	if (locale === "es") return es_a11y_statement_accessible_dnd(inputs)
	if (locale === "it") return it_a11y_statement_accessible_dnd(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_dnd(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_dnd(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_dnd(inputs)
	if (locale === "da") return da_a11y_statement_accessible_dnd(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_dnd(inputs)
	return en_a11y_statement_accessible_dnd(inputs)
});